module.exports = __webpack_public_path__ + "img/luxian-icon-selected.fee3527c.svg";